import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#EF3024',
        secondary: '#536DFE',
        accent: '#EF3024',
        error: '#EF3024',
        info: '#E0E0E0',
        success: '#7b7b7b',
        warning: '#282829',
      },
      dark: {
        primary: '#64B5F6',
        secondary: '#64B5F6',
        accent: '#EF5350',
        error: '#FF5252',
        info: '#383838',
        success: '#03DAC6',
        warning: '#FFC107',
      },
    }
  }
});
